<template lang="html">
  <div class="sub-nav-wrapper">
      <div>
        <div class="cover" v-if="!!icon"><img :src="icon" alt=""></div>
        <ul class="sub-nav">
          <li class="sub-nav-item" v-for="(item,index) in children" :key="index" @click="subMenuClick" v-if="!item.hidden">
            <router-link v-if="!item.meta.disabled" :to='item.meta.path' class="a">{{$t(item.meta.key)}}</router-link>
            <!-- <div v-if="item.meta.disabled" class="a disabled" @click="tips">{{item.meta.title}}</div> -->
            <div v-if="item.meta.disabled" class="a disabled" @click="tips">{{$t(item.meta.key)}}</div>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
export default {
    props: {
      icon:{type:String,default:''},
      children: {
        type: Array,
        default(){return []}
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    data() {
        return {
            title: "abcd",
        }
    },
    created(){
      // console.log(this.children);
    },
    methods:{
      subMenuClick(){
        this.$emit('subMenuClick');
      },
      tips(){
        this.$message('暂未开放，敬请期待！');
      }
    }
}
</script>

<style scoped>
.sub-nav-wrapper {
    width: 80%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: -20%;
    background: #fff;
    z-index: -2;
    -webkit-box-shadow: 0 0 5px 0 #99a0a7;
    box-shadow: 0 0 5px 0 #99a0a7;
    -webkit-transition: left .4s cubic-bezier(.645,.045,.355,1) .1s;
    transition: left .4s cubic-bezier(.645,.045,.355,1) .1s;
}
.sub-nav-wrapper>div {
    height: 100vh;
    width: 100%;
    overflow: hidden;
}
.sub-nav-wrapper>div .cover {
    width: 8.125vw;
    margin: .78125vw auto 2vw;
}
.sub-nav-wrapper>div .cover img {
    width: 100%;
}
.sub-nav-wrapper>div .sub-nav .sub-nav-item {
    overflow: hidden;
}
.sub-nav-wrapper>div .sub-nav .sub-nav-item>.a {
    display: block;
    text-align: center;
    padding: .625vw .52083333vw;
    margin: .67708333vw 0;
    cursor: pointer;
    position: relative;
    font-size:0.85vw;
}

.sub-nav-wrapper>div .sub-nav .sub-nav-item>a.a:hover ,.sub-nav .router-link-active{
    background: #f2f3f7; color:#d70e19;
}
</style>
